var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinnerBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296",
    transform: "translate(-174 -1896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(174 1896)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "receipt_long-24px",
    transform: "translate(190 1912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M-22.514-91.215a5.439,5.439,0,0,1-.558,1.9,5.8,5.8,0,0,1-1.1,1.493,6.267,6.267,0,0,1-1.508,1.086,8.631,8.631,0,0,1-1.75.679l7.21,9.5H-23.66L-29-83.643a8.365,8.365,0,0,0-1.584-1.7,2.462,2.462,0,0,0-1.493-.528v-2.2h1.78a11.5,11.5,0,0,0,1.795-.136,5.3,5.3,0,0,0,1.554-.483,3.337,3.337,0,0,0,1.161-.95,2.956,2.956,0,0,0,.558-1.569H-32.62l.905-1.78h6.365a3.479,3.479,0,0,0-1.177-1.991A3.951,3.951,0,0,0-28.97-95.8h-3.65l.905-1.78h13.243l-.905,1.78h-4.4a5.053,5.053,0,0,1,1.237,2.806h4.073l-.905,1.78Z",
    transform: "translate(45.854 105.238)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M40.225-25.708A1.69,1.69,0,0,0,38.584-27H31.49c.017-.876.012-1.666-.007-2.322a2.241,2.241,0,0,0-2.25-2.178H11.268a2.241,2.241,0,0,0-2.25,2.178C9-28.666,8.994-27.876,9.011-27H1.916A1.69,1.69,0,0,0,.275-25.708a15.525,15.525,0,0,0,2.331,11.5c2.633,3.925,7.07,6.682,13.185,8.252,1.315.338,2.771,1.562,2.771,2.92h0V1.125H12.938a1.687,1.687,0,0,0,0,3.375H27.563a1.687,1.687,0,0,0,0-3.375H21.938V-3.04c0-1.356,1.457-2.579,2.771-2.917,6.114-1.571,10.552-4.328,13.185-8.252A15.525,15.525,0,0,0,40.225-25.708ZM5.443-16.042A12.309,12.309,0,0,1,3.4-23.625H9.057c.377,4.192,1.429,9.278,4.052,13.293A16.079,16.079,0,0,1,5.443-16.042ZM20.25-6.75c-3.917-4.382-7.9-8.515-7.875-21.375h15.75C28.146-15.269,24.168-11.136,20.25-6.75Zm14.807-9.292a16.079,16.079,0,0,1-7.666,5.711c2.624-4.015,3.676-9.1,4.052-13.293H37.1A12.3,12.3,0,0,1,35.057-16.042Z",
    transform: "translate(-2 34)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerBg);
export default __webpack_public_path__ + "static/media/winner-bg.7fc70c264354241149c1e9ceb17b182d.svg";
export { ForwardRef as ReactComponent };